<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
    // 引入中文语言包
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
    import { observeImageLoading } from '@/utils/pcImageLoading';

    export default {
        name: 'App',
        data() {
            return {
                locale: zhCN, // 绑定中文配置
            };
        },
        mounted() {
            this.stopImageLoading = observeImageLoading(this.$el, () => this.$route.path.startsWith('/pc'));
        },
        beforeDestroy() {
            if (this.stopImageLoading) this.stopImageLoading();
        },
    };
</script>

<style>
    .pc-image-loading { position: absolute; display: flex; align-items: center; justify-content: center; background: #f5f7fa; pointer-events: none; z-index: 1; overflow: hidden; }
    img.pc-image-placeholder { min-width: 120px; min-height: 120px; }
    html,
    body,
    #app {
        height: 100%;
        overflow: hidden;
    }

    .pc-container {
        width: 1200px;
        max-width: none;
        margin-left: auto;
        margin-right: auto;
        box-sizing: border-box;
    }
</style>
